import { Card, Divider, Flex, Skeleton } from 'antd';
import TaskInfo from 'components/TaskInfo';

const TaskDetailsSkeleton = () => {
  return (
    <Flex vertical gap={16} align="flex-start">
      <Card className="w-100">
        <Flex vertical gap={16}>
          {/* Status Tag Skeleton */}
          <div className="d-flex">
            <Skeleton.Button
              active
              size="small"
              className="rounded-pill"
              style={{ width: 80 }}
            />
          </div>

          {/* Time Window Card Skeleton */}

          <Card size="small" className="bg-light border">
            <Flex className="row-wrap-container" align="center">
              <TaskInfo
                header={
                  <Skeleton.Input
                    active
                    size="small"
                    className="mb-2"
                    style={{ width: 90 }}
                  />
                }
                renderValue={() => (
                  <Skeleton.Input
                    active
                    size="default"
                    style={{ width: 150 }}
                  />
                )}
              />
              <TaskInfo
                header={
                  <Skeleton.Input
                    active
                    size="small"
                    className="mb-2"
                    style={{ width: 90 }}
                  />
                }
                renderValue={() => (
                  <Skeleton.Input
                    active
                    size="default"
                    style={{ width: 200 }}
                  />
                )}
              />
            </Flex>
          </Card>

          <Divider className="m-0 opacity-50" />

          {/* Task Info Grid Skeleton */}

          <Flex wrap={'wrap'} className="row-wrap-container">
            {[...Array(6)].map((_, index) => (
              <TaskInfo
                key={index}
                header={
                  <Skeleton.Input
                    active
                    size="small"
                    className="mb-1"
                    style={{ width: 100 }}
                  />
                }
                renderValue={() => (
                  <Skeleton.Input
                    active
                    size="default"
                    style={{ width: '85%' }}
                  />
                )}
              />
            ))}
          </Flex>

          <Flex align="center" gap={2} className="mt-2">
            <Skeleton.Input active size="default" style={{ width: 100 }} />
            <Skeleton.Node
              active
              className="rounded"
              style={{ width: 12, height: 12 }}
            />
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

export default TaskDetailsSkeleton;
